import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Square = createSvgIcon(
  () => (
    <path d="M39.0625 0H4.6875C2.05078 0 0 2.14844 0 4.6875V39.0625C0 41.6992 2.05078 43.75 4.6875 43.75H39.0625C41.6016 43.75 43.75 41.6992 43.75 39.0625V4.6875C43.75 2.14844 41.6016 0 39.0625 0ZM40.625 39.0625C40.625 39.9414 39.8438 40.625 39.0625 40.625H4.6875C3.80859 40.625 3.125 39.9414 3.125 39.0625V4.6875C3.125 3.90625 3.80859 3.125 4.6875 3.125H39.0625C39.8438 3.125 40.625 3.90625 40.625 4.6875V39.0625Z" />
  ),
  '0 0 44 44'
);
